// extracted by mini-css-extract-plugin
export var errorsContainer = "_v3-1";
export var link = "_v3-0";